"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientHelmetProvider = void 0;
const React = require("react");
const react_helmet_async_1 = require("react-helmet-async");
const BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
class ClientHelmetProvider extends BaseProvider_1.BaseProvider {
    constructor() {
        super({});
    }
    component(children) {
        return React.createElement(react_helmet_async_1.HelmetProvider, { context: this.provider }, children);
    }
}
exports.ClientHelmetProvider = ClientHelmetProvider;
//# sourceMappingURL=ClientHelmetProvider.js.map